// 导航栏 / 轮播 共用图标映射（单一数据源，保证后台选择器与首页渲染一致）
import {
  Promotion, Document, Grid, Connection, Monitor, Share, Cloudy, Van,
  OfficeBuilding, Star, Location, TrendCharts, Collection, ShoppingCart,
  VideoCamera, Phone, Message, Wallet, HomeFilled, Sunny, DataLine,
  Calendar, CircleCheck, Crop, Timer, Right, Cpu, Box, Setting, Search,
  Link, Picture, ChatDotRound, Tickets, Guide, Plus
} from '@element-plus/icons-vue'

export const ICON_MAP = {
  Promotion, Document, Grid, Connection, Monitor, Share, Cloudy, Van,
  OfficeBuilding, Star, Location, TrendCharts, Collection, ShoppingCart,
  VideoCamera, Phone, Message, Wallet, HomeFilled, Sunny, DataLine,
  Calendar, CircleCheck, Crop, Timer, Right, Cpu, Box, Setting, Search,
  Link, Picture, ChatDotRound, Tickets, Guide, Plus
}

export const ICON_NAMES = Object.keys(ICON_MAP)

// 按名称解析图标组件，找不到时回退到 Promotion
export const resolveIcon = (name) => ICON_MAP[name] || ICON_MAP.Promotion